/*
 * Copyright (c) 2022-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: MyLabelLoginForm.tsx
 * Project: mle-client-n
 * Committed last: 2022/5/26 @ 949
 * ---
 * Description:
 */

import {observer} from 'mobx-react';
import {Button, FormGroup, InputGroup, Intent} from '@blueprintjs/core';
import React, {useCallback, useState} from 'react';
import {mleDomainGqlClient} from '../../api/domain';
import {ML_LOGIN} from '../../api/domain/mutations.gql';
import {MleToaster, Toasts} from '../../common/toast';
import {Editor} from '../../store/observables/Editor';
import {MyLabelAuthFeature} from '../../store/features/mylabel/auth/MyLabelAuthFeature';

interface Props {
  editor?: Editor;
  onLoginSuccessful: () => void;
  onLoginError: () => void;
  useFullSpace?: boolean;
}

export const MyLabelLoginForm = observer((props: Props) => {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);

  const handleLogin = useCallback(async () => {
    setIsLoading(true);
    try {
      await mleDomainGqlClient.mutate({
        mutation: ML_LOGIN,
        variables: {
          username: userName,
          password
        }
      });

      MleToaster.getInstance().show(Toasts.ML_LINK_SUCCESSFUL);

      // Remember this credentials
      if (props.editor) {
        props.editor.mylabelAuthFeature.setAuthenticated(userName, password);
        props.editor.requiresMLAuth = false;
      } else {
        window.localStorage.setItem(MyLabelAuthFeature.__usr_key, userName);
        window.localStorage.setItem(MyLabelAuthFeature.__usr_pwd, password);
      }

      props.onLoginSuccessful();
    } catch (e) {
      MleToaster.getInstance().show(Toasts.ML_LINK_FAILED);
      props.onLoginError();
    }

    setIsLoading(false);
  }, [userName, password]);

  const lockButton = (
    <Button
      icon={ passwordVisible ? 'unlock' : 'lock' }
      intent={ Intent.WARNING }
      minimal={ true }
      onClick={ () => setPasswordVisible(!passwordVisible) }
    />
  );

  return (
    <div>
      <form className={ !props.useFullSpace ? 'w-1/2' : 'w-full' }>
        <FormGroup label="Username" labelInfo="(richiesto)">
          <InputGroup
            placeholder="Nome utente"
            onChange={ (event) => setUserName(event.target.value) }
            value={ userName }/>
        </FormGroup>
        <FormGroup label="Password" labelInfo="(richiesto)">
          <InputGroup
            placeholder="Password"
            onChange={ (event) => setPassword(event.target.value) }
            value={ password } leftIcon="shield"
            type={ passwordVisible ? 'text' : 'password' }
            rightElement={ lockButton }
          />
        </FormGroup>
        <Button loading={ isLoading } onClick={ handleLogin }
                intent={ Intent.PRIMARY }>Accedi e
          collega</Button>
      </form>
    </div>
  );
});